class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.wrapper = this.querySelector('.cart-notification-wrapper');
    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.topHeader = document.getElementById('shopify-section-header')
    this.onBodyClick = this.handleBodyClick.bind(this);

    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
        closeButton.addEventListener('click', this.close.bind(this))
    );
  }

  open() {
    document.body.classList.add('cart-notification-open');
    this.notification.classList.add('animate', 'active');
    this.wrapper.classList.add('animate', 'active');
    this.topHeader.classList.add('menu-open');
    this.notification.addEventListener('transitionend', () => {
      this.notification.focus();
      trapFocus(this.notification);
    }, { once: true });

    document.body.addEventListener('mouseup', this.onBodyClick);

  }

  close() {
    document.body.classList.remove('cart-notification-open');
    this.notification.classList.remove('active');
    this.wrapper.classList.remove('active');
    this.topHeader.classList.remove('menu-open');

    document.body.removeEventListener('mouseup', this.onBodyClick);

    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState) {
    this.getSectionsToRender().forEach((section => {
      if(section.id === 'cart-notification-product') {
        let render_section = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
        let parser = new DOMParser();
        let render_count = parser.parseFromString(render_section, 'text/html')?.querySelector('.drawer-count-copy')?.innerHTML;
        const heading_count = document.querySelector('.cart-notification__heading .drawer-count');
        heading_count.innerHTML = render_count;
      }
      document.getElementById(section.id).innerHTML =
          this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    }));

    let totalCost = document.querySelector('.cart-item-row .total-price')?.value;

    document.getElementById('subtotal').innerHTML = totalCost;
    document.querySelector('.btn-money').innerHTML = totalCost;



    if (this.header) this.header.reveal();
    this.open();

    const cartOrderAccordion = new ProductAccordion('.cartOrder__accordion-heading');
    cartOrderAccordion.showAll();
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: '.cart-notification-wrapper',
      },
      {
        id: 'cart-icon-bubble'
      }
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
        .parseFromString(html, 'text/html')
        .querySelector(selector)?.innerHTML;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target?.classList?.contains('cart-notification-wrapper')) {
      const disclosure = target.closest('details-disclosure, header-menu');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);